<article class="dim-card" [class.is-enabled]="enabled">
  <header class="dim-card-header">
    <label class="dim-card-toggle">
      <input type="checkbox" class="kpi-switch"
        [checked]="enabled"
        [disabled]="!editable"
        [attr.aria-label]="'Use ' + heading"
        (change)="onEnabledChange($event)">
      <span class="dim-card-heading">
        <span class="dim-card-title">{{ heading }}</span>
        @if (caption) {
          <span class="dim-card-caption">{{ caption }}</span>
        }
      </span>
    </label>
    <span class="dim-card-position" [class.is-set]="enabled && order > 0" title="Dimension order position">
      {{ enabled && order > 0 ? ordinal(order) : '—' }}
    </span>
  </header>

  <div class="dim-card-fields">
    <label class="kpi-field dim-card-name">
      <span class="kpi-field-label">Dimension</span>
      <select class="kpi-input" [disabled]="!editable || !enabled" (change)="onDimensionNameChange($event)">
        <option value="" disabled [selected]="!dimensionName">- Please select -</option>
        @for (name of dimensionNames; track name) {
          <option [value]="name" [selected]="name === dimensionName">{{ name }}</option>
        }
      </select>
    </label>
    <label class="kpi-field dim-card-order">
      <span class="kpi-field-label">Position</span>
      <select class="kpi-input" [disabled]="!editable || !enabled" (change)="onOrderChange($event)">
        @if (!enabled || order === 0) {
          <option value="0" disabled selected>—</option>
        }
        @for (position of positions; track position) {
          <option [value]="position" [selected]="enabled && position === order">{{ ordinal(position) }}</option>
        }
      </select>
    </label>
  </div>

  <app-check-list
    [formControl]="control"
    [items]="items"
    bindLabel="Description"
    bindValue="Code"
    [ariaLabel]="heading + ' values'"
    [emptyText]="emptyText">
  </app-check-list>
</article>
